import axios from 'axios';

import routes from 'app/routes';

import Swal from 'sweetalert2/dist/sweetalert2';
import settings from 'components/new_ui/Alerts/settings';

export default {
  prepareProgramShare: (programId, callback) => {
    axios
      .get(routes.api.programs.prepareShare(programId))
      .then((resp) => {
        callback(resp.data.data);
      });
  },
  share: (programId, values, callback) => {
    axios
      .post(routes.api.programs.share(programId), values)
      .then((resp) => {
        callback(resp.data.data);
      });
  },
  googleShare: (requiredActionId, callback) => {
    Swal.fire({
      ...settings,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showConfirmButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      title: 'Share Your Feedback',
      text: `Thank you for sharing your feedback with us! If you’d like, 
      please consider leaving us a review on Google as well—it would be greatly 
      appreciated!`,
    }).then((result) => {
      callback();

      axios
        .post(routes.api.required_actions.skip, {
          ids: [requiredActionId],
        })
        .then((_resp) => {
          if (result.isConfirmed) {
            window.open('https://g.page/r/CRVER54hSWBJEBE/review', '_blank', 'noreferrer');
          }
        });
    });
  },

};
